import React from 'react';
import { CategoriaTorneio } from '../../../../services/categoriaTorneioService';

interface CategoryMatchesHeaderProps {
  categoria: CategoriaTorneio;
  torneioId: string;
}

const CategoryMatchesHeader: React.FC<CategoryMatchesHeaderProps> = ({
  categoria,
  torneioId,
}) => {
  return (
    <div className="card w-100 shadow-xss rounded-xxl border-0 mb-3">
      <div className="card-body p-4">
        <div className="d-flex align-items-center">
          <img
            src={categoria.torneio.avatarUrl || '/assets/images/tournament.png'}
            alt={categoria.torneio.nome}
            className="rounded-circle me-3"
            style={{ width: '64px', height: '64px', objectFit: 'cover' }}
          />
          <div className="flex-grow-1">
            <h4 className="fw-700 mb-1">{categoria.torneio.nome}</h4>
            <h5 className="fw-600 text-muted mb-0">{categoria.nome}</h5>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryMatchesHeader;

